export default {
  title: '사이어티에 대해\n' + '더 자세히 알려드릴게요!',
  questions: [
    {
      question: '커뮤니티를 만들고 싶어요! 1:1 상담을 받을 수 있나요?',
      answer:
        '커뮤니티를 만들고 싶은 데, 어떤 플랫폼을 선택해야 할지 고민하고 계시다면,\n' +
        '이름, 연락처, 소셜 링크와 궁금한 문의사항을 적어 <a href="mailto:contact@ciety.io">contact@ciety.io</a> 으로 보내주세요.\n\n' +
        '사이어티 프로덕트 팀은 언제나 커뮤니티 개설을 도울 준비가 되어 있습니다.',
    },
    {
      question: '유튜브 크리에이터가 아니라도 커뮤니티를 만들 수 있나요?',
      answer:
        '네! 사이어티에서는 누구나 쉽게 커뮤니티를 개설할 수 있습니다.\n\n' +
        '학교 친구들과 스터디 과제를 공유하거나, 좋아하는 게임 길드를 만들어 라이브 스트리밍으로 함께 게임하거나,\n' +
        '취미 동아리 커뮤니티를 개설해 이벤트를 만드는 등 관심 있는 주제로 커뮤니티를 만들어 자유롭게 소통해 보세요.\n\n' +
        '유튜브 채널이 아니라도, 인스타그램이나 X(구 트위터), 틱톡, 페이스북 등에서 크리에이터로 활동하고 계신다면\n' +
        '사이어티에서 커뮤니티를 만들어 보세요. 글과 사진, 영상, 라이브 스트림, 굿즈 판매, 유료 클래스 판매까지 \n' +
        '원하는 모든 걸 사이어티에서 나눠 보세요.',
    },
    {
      links: [
        { label: '마플샵 홈페이지', url: 'https://marpple.shop/kr' },
        {
          label: '마플샵 크리에이터 신청',
          url: 'https://marpple.shop/kr/@/hello',
        },
      ],
      question: '커뮤니티 유료 멤버십을 만들 수 있나요?',
      answer:
        '크리에이터 커머스 마플샵에서 멤버십을 만들고 사이어티 커뮤니티를 연동하면 커뮤니티 유료 멤버십을 운영할 수 있습니다.\n' +
        '아래 마플샵 상품 혜택, 사이어티 커뮤니티 혜택, 크리에이터 혜택 세 가지 유형의 혜택으로 특별한 멤버십을 만들어 보세요!' +
        '<ul><li>마플샵 상품 혜택 (멤버십 전용 상품)<br/>' +
        '멤버십 회원만 구매할 수 있는 특별한 전용 상품 구매 혜택을 제공해 보세요.</br>' +
        '마플샵 굿즈 제작 상품, 크리에이터 등록 상품, 디지털 상품 유형별 추가가 가능합니다.</li></br>' +
        '<li>사이어티 커뮤니티 혜택<br/>' +
        '사이어티 커뮤니티를 연동하면 멤버십 그룹에 커뮤니티 혜택을 줄 수 있어요.<br/>' +
        '디지털 콘텐츠, 라이브 방송, 채팅 채널, 1:1 메시지 혜택 등을 멤버십에게만 제공해 보세요.</li><br/>' +
        '<li>크리에이터 혜택<br/>' +
        '크리에이터가 자유롭게 작성할 수 있는 혜택입니다.<br/>' +
        '팬들이 좋아할 만한 혜택을 직접 작성해 제공할 수 있습니다.</li></ul>',
    },
    {
      question: '사이어티 계정 하나로 커뮤니티를 여러개 생성할 수 있나요?',
      answer:
        '물론이죠. 사이어티에서는 계정 하나로 다수의 커뮤니티를 개설할 수 있습니다.' +
        '<ul><li>취미 동아리, 업무 스터디, 학교 과제 모임, 지역 커뮤니티, 팬카페 등의 다양한 커뮤니티를 만들어 보세요.</li>' +
        '<li>커뮤니티에서 글과 사진, 영상을 남기는 포스팅 채널, 채팅 채널, 라이브 스트림 채널을 생성해 내 커뮤니티를 더욱 풍부하게 만들어 보세요.</li>' +
        '<li>커뮤니티에서 그룹 별로 권한을 다르게 설정하여 내 커뮤니티를 보다 섬세하게 관리해 보세요.</li></ul>' +
        '사이어티는 무제한 커뮤니티 개설, 무제한 채널 생성, 무제한 멤버 그룹 생성으로 자유도 높은 커뮤니티 플랫폼을 경험할 수 있습니다.',
    },
    {
      question: '커뮤니티 채널 설정에 대해 자세히 알고 싶어요!',
      answer:
        '사이어티 커뮤니티에서 채널이란, 포스트나 채팅, 라이브 스트림을 업로드하는 게시판과 같은 의미를 가집니다.\n' +
        '사이어티 커뮤니티의 채널 설정에서는 아래와 같은 기능을 설정할 수 있습니다.' +
        '<ul><li>채널 타입 선택, 채널 명, 채널 설명 작성</li>' +
        '<li>채널 공개 설정 : 공개 / 제한 / 비공개</li>' +
        '<li>채널 권한 설정 : 선택한 멤버 그룹의 해당 채널 권한 설정</li></ul>' +
        '사이어티 커뮤니티는 포스트 에디터를 갖춘 포스트 채널· 채팅 채널· 라이브 스트림 채널 세 가지 타입이 있습니다.\n' +
        '채널은 무제한 생성 가능하기 때문에 다양한 이야기를 나누는 자유로운 커뮤니티를 만들어 관리해 보세요.',
    },
    {
      question: '커뮤니티 그룹 설정에 대해 자세히 알고 싶어요!',
      answer:
        '사이어티 커뮤니티에서는 다양한 멤버 그룹을 무제한 만들어, 섬세하게 권한을 부여할 수 있습니다.\n' +
        '커뮤니티 내 모든 멤버들은 그룹이 없거나 혹은 다수의 그룹에 속할 수 있습니다.' +
        '<ul><li>그룹 이름 작성, 색상 선택</li>' +
        '<li>그룹 권한 설정 : 커뮤니티, 멤버, 채널, 게시물, 기프톡 관리 등의 권한 설정</li></ul>' +
        '무제한 그룹 생성과 섬세한 권한 설정으로 커뮤니티와 멤버들을 쉽게 관리해 보세요.',
    },
    {
      question: '커뮤니티 디자인 커스텀은 어디까지 가능한가요?',
      answer:
        '사이어티에서는 PC와 모바일 앱의 커버 이미지를 등록해 커뮤니티 홈을 커스텀 할 수 있습니다.\n\n' +
        '현재 사이어티 커뮤니티는 다크 모드만 지원하고 있기 때문에 다소 제한적인 디자인 일 수 있지만,\n' +
        '추후 라이트 모드 외에도 커뮤니티만의 이미지를 보여줄 수 있는 디자인 커스텀을 위해 기능 고도화를 계획하고 있습니다.',
    },
    {
      question: '커뮤니티마다 알림 설정을 다르게 할 수 있나요?',
      answer:
        '네! 사이어티는 커뮤니티마다 알림 설정을 끄거나 켤 수 있고,\n' +
        '커뮤니티 내 채널마다 알림을 ON/OFF 할 수도 있습니다.\n\n' +
        '모바일 앱에서는 앱 설정에서 배지 알림, 사운드 등의 알림 설정이 가능합니다.',
    },
    {
      links: [
        { label: '마플샵 홈페이지', url: 'https://marpple.shop/kr' },
        {
          label: '마플샵 크리에이터 신청',
          url: 'https://marpple.shop/kr/@/hello',
        },
      ],
      question: '커뮤니티 굿즈를 만들어 판매하고 싶어요!',
      answer:
        '사이어티에서는 크리에이터의 스토어 개설부터 간편 결제, 굿즈 제작, 배송, 고객 관리까지 올인원 커머스 마플샵 연동을 지원합니다.\n\n' +
        '마플샵 가입 후, 크리에이터 신청 절차를 거쳐 승인을 받으면 단 며칠 만에 스토어를 오픈하고\n' +
        '나만의 디자인으로 쉽게 굿즈를 만들어 재고 없이 바로 판매할 수 있어요.\n' +
        '1,200여 종의 다양한 굿즈를 만들어 사이어티 커뮤니티에서 판매해 보세요.\n\n' +
        '사이어티 커뮤니티 샵에 마플샵 아이디를 연결하면, 커뮤니티 채널 리스트 상단에 마플샵 상품이 노출됩니다.\n' +
        '커뮤니티 멤버의 아이디어와 니즈를 반영한 굿즈 상품 외에도 다양한 수익화를 기획해 보세요.\n' +
        '콘서트 티켓, 브랜드 광고/콜라보 상품, 핸드메이드 상품, 디지털 상품(핸드폰 배경화면, mp3 음원 등) 등 상품 유형의 제약 없이 판매할 수 있습니다.\n\n',
    },
    {
      question: '사이어티 커뮤니티에서 라이브 스트리밍도 가능한가요?',
      answer:
        '사이어티에서는 커뮤니티에서 라이브 스트리밍을 할 수 있습니다.\n\n' +
        '라이브 스트림 채널 타입을 선택해 채널을 만들고 공개 설정과 권한 설정으로\n' +
        '라이브 스트리밍을 멤버 누구나 할 수 있거나, 관리자만 업로드할 수 있는 채널로 관리할 수 있어요.\n' +
        '멤버들과 실시간 게임을 함께 하고 커뮤니티 주제 관련 강의를 하고 매일 하루 일과를 나누는 가벼운 소통을 실시간 라이브 스트리밍으로 나눠 보세요.\n\n' +
        '방송 종료 이후 영상과 채팅이 라이브 스트림 채널에 그대로 기록되며,\n' +
        '유튜브 라이브와 동시 송출도 가능해서 내 유튜브 채널과 커뮤니티를 한 번에 쉽게 관리할 수 있습니다.',
    },
    {
      question: '유료 콘텐츠/클래스는 어떻게 만들어 판매하나요?',
      answer:
        '사이어티에서는 커뮤니티에서 콘텐츠를 만들어 쉽게 판매해 볼 수 있습니다.\n\n' +
        '포스트 채널, 챗 채널, 라이브 스트림 채널 설정에서 [공개 범위 설정]에서 제한으로 선택하고 참여 가능한 그룹을 설정할 수 있습니다.\n' +
        '유료 멤버십 그룹을 참여 그룹으로 선택하면, 멤버십 그룹만 해당 채널을 열람하고 참여할 수 있기 때문에\n' +
        '다른 클래스 플랫폼을 이용하지 않고도 기존의 콘텐츠나 영상을 모아 유료화해서 판매할 수 있습니다.\n\n' +
        '사이어티 커뮤니티를 활용해 다양한 크리에이터 이코노미를 실현해 보세요.',
    },
    {
      question: '[가입/로그인] 가입을 시도하는데 “계정 연결”은 왜 뜨는 건가요?',
      answer:
        '“계정 연결”이란 고객님의 아이디(이메일)에 SNS계정을 로그인 수단으로 연결해 드리는 작업입니다.\n' +
        'SNS계정으로 맨 처음 회원 가입을 시도하시면 해당 SNS에 연락처로 등록된 이메일이 MCO 회원 인지 검사하는데,\n' +
        'MCO아이디(이메일)가 발견되어 "계정 연결" 과정이 시작 된 것입니다.\n\n' +
        '보안을 위해 기존 아이디에 최초 1회 로그인을 거치고 나면 연결이 완료되며,\n' +
        '다음 로그인 부터 기존 방법 뿐 아니라 방금 추가한 SNS로도 로그인 하실 수 있어요.\n\n' +
        '“계정 연결”을 거치면 중복 아이디가 생기는 것을 막아 회원님이 사용하는 여러 소셜 계정을 기존 MCO 아이디에 로그인 수단으로 추가할 수 있어\n' +
        '모바일과 PC, 앱 등에서도 빠르게 로그인 할 수 있답니다.',
    },
    {
      question:
        '[가입/로그인] SNS 회원 가입 시 “계정 연결” 대신 새로 가입하고 싶어요.',
      answer:
        '소셜 로그인으로 회원가입/로그인 을 처음 시도하실 때\n' +
        '해당 소셜 서비스에서 사용중인 이메일이 기존 MCO에 가입된 아이디(이메일)이면, 계정 연결 과정이 시작됩니다.\n' +
        '두 개의 계정을 만들어 사용하고 싶다면 서로 다른 이메일을 사용해야 합니다.\n' +
        '다음 두 가지 방법 중 좀 더 편한 방법을 사용하세요.\n\n' +
        '1. 새로운 이메일로 회원가입 후 마이페이지 > 계정설정에서 해당 소셜 로그인수단을 추가하세요.\n' +
        '2. 기존 사용중인 계정의 이메일을 변경하고, SNS로 회원가입을 시도하세요.\n\n' +
        '아울러, 이용 약관에 의거 두 계정을 하나로 병합하는 것은 불가능 하니 이용에 참고해주세요.',
    },
    {
      question:
        '[가입/로그인] 기존에 가입한 이메일 회원은 어떻게 SNS 소셜 로그인을 이용하나요?',
      answer:
        '기존 이메일 회원이 소셜로그인 수단을 추가하는 방법은 두 가지가 있습니다.\n\n' +
        '1. 로그인 후 마이페이지 > 계정 설정 > SNS 계정 연결 에서 다양한 SNS 로그인 수단을 연결/해제 할 수 있어요.\n' +
        '카카오, 네이버, 구글, 애플, 페이스북 중 원하시는 수단을 클릭 후 해당 SNS로 로그인을 진행하면 연결이 활성화됩니다.\n' +
        '연결 해제를 원하실 경우, 활성화된 아이콘을 클릭해 주세요.\n\n' +
        '2. SNS에서 연락처로 사용중인 이메일이 MCO 회원 아이디(이메일)와 같다면 SNS 최로 초그인 시 “계정 연결” 과정을 거쳐 로그인 수단으로 추가됩니다.\n' +
        '이 경우에도 기존 계정의 본인확인(비밀번호 입력)이 필요합니다.',
    },
    {
      question:
        '[가입/로그인] 소셜로그인 수단으로 가입했는데, 소셜 로그인을 사용할수 없는 상황이에요.',
      answer:
        '소셜 로그인으로 가입할 때 등록된 이메일과 비밀번호로 로그인할 수 있습니다.\n\n' +
        '1. 이미 비밀번호를 등록하셨다면 이메일-비밀번호로 로그인을 시도해주세요.\n' +
        '2. 비밀번호 재설정 - 소셜 계정 로그인에 사용한 이메일로 비밀번호 재설정 링크를 보내고, 비밀번호를 등록해 로그인해주세요',
    },
    {
      question: '[가입/로그인] 여러 계정을 하나로 합칠 수 있나요?',
      answer:
        '마플코퍼레이션(MCO) 회원 시스템은 이용약관에 의거 계정의 양도, 이전, 병합이 불가능합니다.\n' +
        'SNS 연동이 여러 계정에 나뉘어 있어 불편하시다면 Mypage > 계정 설정 에서 연동정보를 정리하실 수 있습니다.',
    },
    {
      type: "DUPLICATE_ACCOUNT",
      question:
        '[계정 설정] SNS 계정 연결을 시도하는데 “중복 계정” 이라고 합니다.',
      answer:
        '연결을 시도 하신 SNS계정이 다른 MCO 아이디(이메일)에 연결되어 있는 상태입니다.\n' +
        'SNS 계정을 고객님의 어느 MCO 아이디(이메일)에 연결 했는지 알고 계신 경우,\n' +
        '해당 MCO 계정으로 로그인하여 SNS 연결을 해제한 후 다시 시도해 주세요.\n\n' +
        '고객님의 어느 아이디에 연결 하셨는지 기억나지 않는 경우에는 소셜 서비스 개인정보 페이지에서 연결을 해제해 주세요.\n' +
        '1. 아래 서비스 별 링크를 참고하여 각 서비스 페이지에서목록에서 “마플코퍼레이션”을 찾아 연결을 해제\n' +
        '2. 연결을 원하는 MCO 회원으로 로그인 > “계정 설정” SNS 계정 연결을 재시도',
    },
    {
      question: '커뮤니티 멤버를 차단하거나 신고 할 수 있나요?',
      answer:
        '커뮤니티 멤버라면 누구든지, 포스트나 댓글, 챗의 내용에 신고 사유가 있을 시, 사이어티 프로덕트 팀에 신고할 수 있습니다.\n' +
        '또한 커뮤니티 활동 중 보고 싶지 않은 멤버를 차단/차단 해제할 수 있습니다.\n\n' +
        '커뮤니티 관리자라면 커뮤니티 멤버를 커뮤니티 내에서 삭제하거나 다시 되돌릴 수도 있습니다.',
    },
    {
      question:
        '사이어티 계정을 삭제하면 커뮤니티와 활동했던 기록은 어떻게 되나요?',
      answer:
        '사이어티 계정을 삭제하더라도 커뮤니티 활동 중 작성한 포스트 등의 데이터는 삭제되지 않습니다.\n' +
        '커뮤니티 관리자라면, 커뮤니티의 관리자 권한을 다른 멤버에게 이전 후, 사이어티 계정을 삭제할 수 있습니다.\n\n' +
        '<p style="color: #CD3849;">! 사이어티 계정을 삭제하면, 해당 계정의 활동 내역이나 커뮤니티 가입 리스트 등에는 더 이상 접근할 수 없습니다.</p>',
    },
    {
      question: '사이어티 커뮤니티를 삭제할 수 있나요?',
      answer:
        '커뮤니티를 삭제하시려면 사이어티 프로덕트 팀 <a href="mailto:contact@ciety.io">contact@ciety.io</a>으로 문의해 주시기 바랍니다.\n\n' +
        '<p style="color: #CD3849;">! 사이어티 커뮤니티를 삭제하면, 커뮤니티에 남겨진 모든 데이터는 다시 복구할 수 없습니다.</p>',
    },
  ],
};
